








































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import Timeline from '@/models/Timeline';
// eslint-disable-next-line no-unused-vars
import Node from '@/models/Node';
import ProjectServer from '@/models/ProjectServer';
import { mapGetters } from 'vuex';
import { SendPacket } from '@/networking/SendPacket';
import { PacketType } from '@/models/Packet';
import Mutations from '@/store/mutations';

@Component({
    components: {
		
    },
    computed: {
        ...mapGetters([
        ])
    }
})
export default class EventListElement extends Vue 
{
	@Prop(Number) readonly nodeid!: Number;
    @Prop(Boolean) readonly disableInsertAfter!: Boolean;

	targetTouch : any = null;

	get event() : Node
	{
	    return this.$store.getters.nodes.get(this.nodeid);
	}

	clicked()
	{
	    this.$store.commit(Mutations.setSelected, this.event);
	}

	sendToTop()
	{
	    this.$emit('sendtotop');
	    // await new Promise(resolve => setTimeout(resolve, 50));
	    // (this.$refs.ele as HTMLElement).focus();
	}

	sendToBottom()
	{
	    this.$emit('sendtobottom');
	    // await new Promise(resolve => setTimeout(resolve, 50));
	    // (this.$refs.ele as HTMLElement).focus();
	}

	insertAfterSelected()
	{
	    this.$emit('insertafterselected');
	    // await new Promise(resolve => setTimeout(resolve, 50));
	    // (this.$refs.ele as HTMLElement).focus();
	}

	touchStart(ev : any)
	{
	    if (ev.targetTouches.length === 1)
	    {
	        this.targetTouch = ev.targetTouches.item(0);
	    }
	}

	touchEnd(ev : any)
	{
	    if (this.targetTouch != null && ev.changedTouches.length === 1)
	    {
	        let touch = ev.changedTouches.item(0);
	        let dx = touch.clientX - this.targetTouch.clientX;
	        let dy = touch.clientY - this.targetTouch.clientY;
	        if ((dx * dx) + (dy * dy) < 8)
	        {
	            // didn't drag, do a click
	            this.clicked();
	        }
	    }
	    this.targetTouch = null;
	}
}
